import { format, parseDateFromApi } from '@sequencehq/utils/dates'

// Slice the date-only string rather than `new Date(period)`, which parses as UTC
// midnight and shifts the first of the month into the previous month behind UTC.
export const getPeriodMonthKey = (period: string): string => period.slice(0, 7)

export const isSamePeriod = (period1: string, period2: string): boolean =>
  getPeriodMonthKey(period1) === getPeriodMonthKey(period2)

// Build the label from the same YYYY-MM bucket used for grouping, parsed with the
// shared UTC-safe API-date adapter (`format` also renders in UTC). A raw `new Date`
// would shift the 1st into an adjacent month — back a day ahead of UTC, forward behind
// it — so the label would disagree with the string-derived bucket key.
export const formatPeriodMonthLabel = (period: string): string =>
  format(parseDateFromApi(`${getPeriodMonthKey(period)}-01`) ?? '', 'MMMM yyyy')
